import { Link } from "react-router";
import PropTypes from "prop-types";
import React from "react";

const Slide = ({
  css,
  index,
  item,
  link,
  showImage,
  buildGlobalDetailPage,
  globalListingLink,
  isSelected,
  listing,
}) => {
  let image = (
    <img src={"/img/listing/transparent.png"} alt={"image-" + index} />
  );
  let style = showImage ? { backgroundImage: "url(" + item.src + ")" } : {};
  const tabIndex = isSelected ? "0" : "-1";
  if (item.orientation === "landscape") {
    style.backgroundSize = "cover";
  }

  let linkType = () => {
    if (buildGlobalDetailPage === false) {
      return (
        <a
          tabIndex={tabIndex}
          target="_blank"
          href={globalListingLink}
          aria-label={`Read More about ${listing.title}, ${listing.cityStateCountry}`}
        >
          {image}
        </a>
      );
    } else if (link) {
      return (
        <Link
          tabIndex={tabIndex}
          to={link}
          aria-label={`Read More about ${listing.title}, ${listing.cityStateCountry}`}
        >
          {image}
        </Link>
      );
    } else {
      return image;
    }
  };

  return (
    <div className={"slide " + css} style={style}>
      {linkType()}
    </div>
  );
};

Slide.propTypes = {
  css: PropTypes.string,
  index: PropTypes.number.isRequired,
  item: PropTypes.object.isRequired,
  link: PropTypes.string,
  showImage: PropTypes.bool,
};

export default Slide;



// WEBPACK FOOTER //
// ./src/components/search/result/mini-slideshow/slide.js